import React from 'react'
import styles from './styles.module.css'
import Cart from '@page-components/Order/Cart'
import {useMyOrderPreferences} from '@data/queries/preferences/getMyOrderPreferences'
import Container from '@packages/justo-parts/lib/components/Container'
import Loading from '@page-components/Order/Products/ProductsContent/Loading'
import InfoBanner from '@components/InfoBanner'
import useInitialData from '../useInitialData'
import ClientSuspense from '@components/ClientSuspense'
import LoadingText from '@components/LoadingText'
import usePreferenceStoreId from '@hooks/usePreferencesStoreId'

export interface WebsiteProps {
  showDemo?: boolean
  children: React.ReactNode
}

export default function OnTable(props) {
  const initialData = useInitialData()
  const {website} = initialData
  const {storeId, loading: storeLoading} = usePreferenceStoreId(website._id)
  const {preferences, loading} = useMyOrderPreferences(website._id, storeId, {omit: storeLoading})

  if (!preferences) {
    return (
      <div className={styles.loadingContainer}>
        <Container>
          <Loading />
        </Container>
      </div>
    )
  }

  return (
    <div>
      <ClientSuspense fallback={<LoadingText />}>
        <InfoBanner />
      </ClientSuspense>
      <ClientSuspense fallback={<LoadingText />}>
        <Cart loading={loading} website={website} preferences={preferences} layout="mobile" />
      </ClientSuspense>
      {props.children}
    </div>
  )
}
